module.exports = __webpack_public_path__ + "static/media/twitter.be066898.svg";